// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { OwnerPublicSecurityFragment } from '../../fragments/generated/owner-public-security.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetAllOwnerPublicSecurityQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllOwnerPublicSecurityQueryResult = { __typename?: 'Query', getAllOwnerPublicSecurity: Array<{ __typename?: 'OwnerPublicSecurityDTO', description: string, id: number, ownerId: number, psCode: string | null, psEncryptedPassword: string | null, psIstatGroup: number | null, psKey: string | null, psWithRoomId: boolean, sendOnline: boolean, publicSecurityType: { __typename?: 'PublicSecurityTypeDTO', countryCode: string, id: number, printable: boolean, printableBlank: boolean, receipt: boolean, sendFile: boolean, sendOnline: boolean, type: Types.PublicSecurityTypeEnum } }> };

export const GetAllOwnerPublicSecurityGql = gql`
    query GetAllOwnerPublicSecurity {
  getAllOwnerPublicSecurity {
    ...OwnerPublicSecurity
  }
}
    ${OwnerPublicSecurityFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllOwnerPublicSecurityInjectable extends Apollo.Query<GetAllOwnerPublicSecurityQueryResult, GetAllOwnerPublicSecurityQueryVariables> {
    override document = GetAllOwnerPublicSecurityGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */